var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#677283",
    d: "M 2.9055188,1.5788192 C 2.3532569,1.5788744 1.5927778,2.2824815 1.5927226,2.8347434 V 21.136821 c 5.52e-5,0.552262 0.7321345,1.290686 1.2843602,1.28436 H 21.17979 c 0.552262,-5.5e-5 1.284305,-0.732098 1.28436,-1.28436 V 2.8347434 c -5.5e-5,-0.5522619 -0.732098,-1.255869 -1.28436,-1.2559242 z m 0.6872038,2 H 20.46415 V 8.4859626 H 3.5927226 Z m 0,6.9071428 h 4.0884817 v 9.935219 H 3.5927226 Z m 6.0884817,0 h 4.6375907 v 9.935219 H 9.6812043 Z m 6.6375907,0 h 4.145355 v 9.935219 h -4.145355 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.5f32dd30.svg";
export { ForwardRef as ReactComponent };